module.exports = __webpack_public_path__ + "images/smartphone-screen-2_507b7acdb65d72090d7054f9b03be7c6.png";